import React from 'react';
import styled from 'styled-components';
import {Link} from 'react-router-dom';

import Popover from '../Popover';
import Button from '../Button';

const Menu = styled(React.forwardRef((props, ref) => <Popover {...props} ref={ref} />))`
  padding: 0.5rem 0;
  background: #FFF;
  border-radius: 0.25rem;
  overflow: hidden;
  box-shadow: 0 0.125rem 0 rgba(90, 97, 105, 0.11),
              0 0.25rem 0.5rem rgba(90, 97, 105, 0.12),
              0 0.625rem 0.625rem rgba(90, 97, 105, 0.06),
              0 0.4375rem 4.375rem rgba(90, 97, 105, 0.1);
`;

const MenuText = styled.div`
  padding: 0.5rem 1rem;
`;

const MenuDivider = styled.div`
  margin: 0.35rem 0;
  height: 0.0625rem;
  background: #E4E4E4;
`;

const MenuOption = styled(props => {
  const {onClick, closeMenu, keepOpen, ...otherProps} = props;
  return props.to
    ? (props.to.startsWith('http') ? <a {...otherProps} href={props.to} /> : <Link {...otherProps} />) // eslint-disable-line
    : (
      <Button
        blank
        {...otherProps}
        onClick={e => {
          if (!keepOpen) {
            closeMenu(e);
          }
          onClick();
        }}
      />
    )
})`
  display: block;
  width: 100%;
  color: #0049EE;
  padding: 0.5rem 1rem;
  text-align: start;
  background: ${props => props.active ? '#F5F5F8' : '#fff'};

  :hover {
    background: #F5F5F8;
  }
`;

const MenuSection = styled(props => {
  const {closeMenu, ...otherProps} = props;
  const children = React.Children.map(props.children, child => child && typeof child === 'object' && React.cloneElement(child, {
    closeMenu: closeMenu
  }));
  
  return (
    <div {...otherProps}>
      {children}
    </div>
  )
})`
  margin-top: 0.625rem;

  :first-child {
    margin-top: 0;
  }
`;

Menu.Text = MenuText;
Menu.Divider = MenuDivider;
Menu.Option = MenuOption;
Menu.Section = MenuSection;
export default Menu;